/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getIntraOPNursingRecords } from 'app/entities/intra-op-nursing-record/intra-op-nursing-record.reducer';
import { CountType } from 'app/shared/model/enumerations/count-type.model';
import { createEntity, getEntity, reset, updateEntity } from './intra-op-count.reducer';

export const IntraOPCountUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const intraOPNursingRecords = useAppSelector(state => state.intraOPNursingRecord.entities);
  const intraOPCountEntity = useAppSelector(state => state.intraOPCount.entity);
  const loading = useAppSelector(state => state.intraOPCount.loading);
  const updating = useAppSelector(state => state.intraOPCount.updating);
  const updateSuccess = useAppSelector(state => state.intraOPCount.updateSuccess);
  const countTypeValues = Object.keys(CountType);

  const handleClose = () => {
    navigate(`/intra-op-count${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getIntraOPNursingRecords({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.sponges !== undefined && typeof values.sponges !== 'number') {
      values.sponges = Number(values.sponges);
    }
    if (values.gauze !== undefined && typeof values.gauze !== 'number') {
      values.gauze = Number(values.gauze);
    }
    if (values.peanut !== undefined && typeof values.peanut !== 'number') {
      values.peanut = Number(values.peanut);
    }
    if (values.cottonoid !== undefined && typeof values.cottonoid !== 'number') {
      values.cottonoid = Number(values.cottonoid);
    }
    if (values.vesselLoop !== undefined && typeof values.vesselLoop !== 'number') {
      values.vesselLoop = Number(values.vesselLoop);
    }
    if (values.rollerGauze !== undefined && typeof values.rollerGauze !== 'number') {
      values.rollerGauze = Number(values.rollerGauze);
    }
    if (values.instrument !== undefined && typeof values.instrument !== 'number') {
      values.instrument = Number(values.instrument);
    }
    if (values.needle !== undefined && typeof values.needle !== 'number') {
      values.needle = Number(values.needle);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...intraOPCountEntity,
      ...values,
      nursingRecord: intraOPNursingRecords.find(it => it.id.toString() === values.nursingRecord?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          countType: 'PREOP',
          ...intraOPCountEntity,
          nursingRecord: intraOPCountEntity?.nursingRecord?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.intraOPCount.home.createOrEditLabel" data-cy="IntraOPCountCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.intraOPCount.home.createOrEditLabel">Create or edit a IntraOPCount</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="intra-op-count-id"
                  label={translate('tinyMedicRestApp.intraOPCount.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPCount.countType')}
                id="intra-op-count-countType"
                name="countType"
                data-cy="countType"
                type="select"
              >
                {countTypeValues.map(countType => (
                  <option value={countType} key={countType}>
                    {translate(`tinyMedicRestApp.CountType.${countType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPCount.sponges')}
                id="intra-op-count-sponges"
                name="sponges"
                data-cy="sponges"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPCount.gauze')}
                id="intra-op-count-gauze"
                name="gauze"
                data-cy="gauze"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPCount.peanut')}
                id="intra-op-count-peanut"
                name="peanut"
                data-cy="peanut"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPCount.cottonoid')}
                id="intra-op-count-cottonoid"
                name="cottonoid"
                data-cy="cottonoid"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPCount.vesselLoop')}
                id="intra-op-count-vesselLoop"
                name="vesselLoop"
                data-cy="vesselLoop"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPCount.rollerGauze')}
                id="intra-op-count-rollerGauze"
                name="rollerGauze"
                data-cy="rollerGauze"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPCount.instrument')}
                id="intra-op-count-instrument"
                name="instrument"
                data-cy="instrument"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPCount.needle')}
                id="intra-op-count-needle"
                name="needle"
                data-cy="needle"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPCount.active')}
                id="intra-op-count-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPCount.cursor')}
                id="intra-op-count-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPCount.lastupdated')}
                id="intra-op-count-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPCount.microSec')}
                id="intra-op-count-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.intraOPCount.timestampentry')}
                id="intra-op-count-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="intra-op-count-nursingRecord"
                name="nursingRecord"
                data-cy="nursingRecord"
                label={translate('tinyMedicRestApp.intraOPCount.nursingRecord')}
                type="select"
                required
              >
                <option value="" key="0" />
                {intraOPNursingRecords
                  ? intraOPNursingRecords.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/intra-op-count" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default IntraOPCountUpdate;
